module.exports = __webpack_public_path__ + "static/media/bfile-watercraft.860732b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-watercraft.svg
// module id = 556
// module chunks = 0